import { Alert } from '@factorialco/deprecated-design-system'
import { uniq } from 'lodash'

import i18n from 'modules/core/lib/i18n'

interface CurrencyWarningProps {
  currencies: string[]
  currency: string
}

const CurrencyWarning = ({ currencies, currency }: CurrencyWarningProps) => {
  return (
    <Alert color="warning">
      {i18n.t(
        'payroll_bundle.results_payments.results.multiple_currencies_in_payroll_policy_warning',
        { currencies: uniq(currencies).join(', '), currency }
      )}
    </Alert>
  )
}

export default CurrencyWarning
